import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { GRID2D__float } from '@/pages/_base/grid2d/views/GRID2D__float';
import { REMOTE__image_asset_filter } from '@/state/images/segment/REMOTE__image_asset_filter';
import { LOCAL__ui_set_image } from '@/state/ui/_base/LOCAL__ui_set_image';
import { assert_array_instanceof } from '@shared/asserts/utils_asserts';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { DTO_REQUEST__image_asset_filter } from '@shared/dto/+image/_requests/DTO_REQUEST__image_asset_filter';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';
import { DTO__entity_with_grid2d } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/DTO__entity_with_grid2d';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { DTO__grid2d_cell } from '@shared/dto/grid2d_cell/DTO__grid2d_cell';
import { DTO__grid2d_chunk } from '@shared/dto/grid2d_chunk/DTO__grid2d_chunk';
import { useState } from 'react';

export function GRID2D__images_select() {
  /*
   * STORE
   */
  const dispatch = use_dispatch();
  const { g_image_edit__replace__category, g_image_edit__replace__workspace_id, g_image_edit__field } = use_slice_ui([
    'g_image_edit__replace__category',
    'g_image_edit__replace__workspace_id',
    'g_image_edit__field',
  ]);

  const [grid2d, set_grid2d] = useState(DTO__grid2d.CREATE_STUB());
  const [entity, set_entity] = useState(DTO__entity_with_grid2d.CREATE_STUB());
  /*
   * EFFECTS
   */

  use_effect(() => {
    void load_images();
  }, [g_image_edit__replace__category, g_image_edit__replace__workspace_id]);

  async function load_images() {
    let request = new DTO_REQUEST__image_asset_filter();
    [request.category, request.workspace_id] = [g_image_edit__replace__category, g_image_edit__replace__workspace_id];

    let action_result = await dispatch(REMOTE__image_asset_filter(request));

    if (!Array.isArray(action_result.payload)) return;

    assert_array_instanceof(action_result.payload, DTO__image_asset);

    let response = action_result.payload as DTO__image_asset[];

    /*
     * CREATE GRID2D
     */

    let entity_new = new DTO__entity_with_grid2d();
    set_entity(entity_new);

    let grid2d_new = new DTO__grid2d();
    [grid2d_new._id] = [ENUM__string_id_empty.OBJECT_ID];
    [grid2d_new.total_cells_amount, grid2d_new.total_images_amount] = [response.length, response.length];
    set_grid2d(grid2d_new);

    let grid2d_chunk = new DTO__grid2d_chunk();
    [grid2d_chunk.grid2d_id, grid2d_chunk._id] = [ENUM__string_id_empty.OBJECT_ID, ENUM__string_id_empty.OBJECT_ID];
    grid2d_chunk.are_cells_loaded_first_time = true;
    grid2d_chunk.cells_amount_before_this_chunk = 0;
    grid2d_chunk.chunk_index = 0;
    [grid2d_chunk.cells_amount, grid2d_chunk.images_amount] = [response.length, response.length];

    for (let image of response) {
      let cell = new DTO__grid2d_cell();
      [cell.grid2d_id, cell.grid2d_chunk_id] = [ENUM__string_id_empty.OBJECT_ID, ENUM__string_id_empty.OBJECT_ID];
      cell.hash_sha256_content = image.hash_sha256_content;
      cell.image = image.clone();

      grid2d_chunk.upsert_cell(cell);
    }

    grid2d_new.chunks.push(grid2d_chunk);

    grid2d_new.on_grid2d_updated();

    /*
     * RESET SELECTION
     */

    dispatch(LOCAL__ui_set_image({ key: 'g_image_edit__select__image_asset', value: g_image_edit__field.asset }));
  }

  /*
   * HTML
   */

  return (
    <div className="size-full bg-component p-0.5">
      <GRID2D__float {...{ grid2d, entity }} use_offset_from_slug={false} />
    </div>
  );
}
